
export const metaNoticeStyles = (theme: ThemeType) => ({
  color: theme.palette.lwTertiary.main,
  fontSize: "1rem",
  marginLeft: theme.spacing.unit / 2,
  ...theme.typography.italic,
});
